import { useViewportSize } from './useViewportSize'
import { UI_TIERS, type UISizing } from '../config/theme'

export function useUI(): UISizing {
  const tier = useViewportSize()
  return UI_TIERS[tier]
}
